/*
* Broadcast Theme - custom.js (vanilla)
*/

/**
 * Event Delegation helper:
 * runs handler when event target (or its parent) matches selector
 */
function on(delegateTarget, eventName, selector, handler) {
  delegateTarget.addEventListener(eventName, (event) => {
    const target = event.target.closest(selector);
    if (!target) return;
    handler(event, target);
  });
}

/**
 * Helper: find nearest parent and then a child inside it
 */
function toggleHasLineItem(clickedEl, add) {
  const wrappers = [
    clickedEl.closest(".form__wrapper"),
    clickedEl.closest(".product-quick-add__form"),
  ].filter(Boolean);

  wrappers.forEach((wrap) => {
    const btn = wrap.querySelector(".btn--primary");
    if (!btn) return;
    btn.classList.toggle("hasLineItem", add);
  });
}

/**
 * Build inactive product galleries only when a customer selects them.
 * Content inside <template> is inert, so its images and swiper instances do
 * not compete with the active product image during the initial page load.
 */
function hydrateVariantGallery(gallery) {
  if (!gallery) return;
  const template = gallery.querySelector(':scope > template[data-variant-gallery-template]');
  if (!template) return;
  template.replaceWith(template.content.cloneNode(true));
  gallery.removeAttribute('data-deferred-variant-gallery');
}

/**
 * 1) Click on select popout option
 */
on(document, "click", ".select-popout__item .select-popout__option", (event, el) => {
  const isFirst = el.classList.contains("first-opt");
  toggleHasLineItem(el, isFirst);

  const popout = el.closest("popout-select");
  const toggle = popout && popout.querySelector("[data-popout-toggle]");
  if (toggle) toggle.setAttribute("aria-invalid", isFirst ? "true" : "false");
});

/**
 * Required line-item dropdowns use their first option as a placeholder.
 * Keep the add-to-cart button clickable, but open the incomplete dropdown
 * instead of submitting the product form.
 */
function findIncompleteRequiredLineItem(form) {
  return Array.from(document.querySelectorAll("input[data-popout-input]")).find((input) => {
    if (input.form !== form) return false;

    const popout = input.closest("popout-select");
    const firstOption = popout && popout.querySelector(".select-popout__option.first-opt");
    return firstOption && input.value === firstOption.getAttribute("data-value");
  });
}

function openIncompleteRequiredLineItem(event, form) {
  const incompleteInput = findIncompleteRequiredLineItem(form);
  if (!incompleteInput) return false;

  event.preventDefault();
  event.stopImmediatePropagation();

  const popout = incompleteInput.closest("popout-select");
  const toggle = popout && popout.querySelector("[data-popout-toggle]");
  if (!toggle) return true;

  toggle.setAttribute("aria-invalid", "true");
  toggle.focus();

  if (toggle.getAttribute("aria-expanded") !== "true") {
    toggle.click();
  }

  return true;
}

document.addEventListener("click", (event) => {
  const button = event.target.closest && event.target.closest("[data-add-to-cart]");
  if (!button) return;

  const form = button.form || button.closest("form[data-product-form]");
  if (!form || !form.hasAttribute("data-product-form")) return;

  openIncompleteRequiredLineItem(event, form);
}, true);

document.addEventListener("submit", (event) => {
  const form = event.target.closest && event.target.closest("form[data-product-form]");
  if (!form) return;

  openIncompleteRequiredLineItem(event, form);
}, true);

/**
 * 2) Change on variant radio buttons (product page)
 * Switch active images based on selected variant id input
 */
on(document, "change", ".product__page .radio__button input", () => {
  const productPage = document.querySelector(".product__page");
  if (!productPage) return;

  // In Broadcast, the selected variant id is usually in input[name="id"]
  const idInput = productPage.querySelector('input[name="id"]');
  if (!idInput) return;

  // Let theme scripts update the hidden variant id first
  setTimeout(() => {
    const val = idInput.value;

    document.querySelectorAll(".custom-variant-images").forEach((n) => n.classList.remove("active"));

    const match = document.querySelector(`.custom-variant-images[data-id="${CSS.escape(val)}"]`);
    const all = document.querySelector(".custom-all-images");

    if (match) {
      hydrateVariantGallery(match);
      if (all) all.classList.remove("active");
      match.classList.add("active");
    } else {
      if (all) {
        hydrateVariantGallery(all);
        all.classList.add("active");
      }
    }
  }, 100);
});

/**
 * 3) Click on a.addsingleproduct -> redirect to data-url
 */
on(document, "click", "a.addsingleproduct", (event, el) => {
  event.preventDefault();
  const redirectUrl = el.getAttribute("data-url");
  if (redirectUrl) window.location.href = redirectUrl;
});

/**
 * 4) Make .column__inner clickable if it contains a link
 */
document.querySelectorAll(".column__inner").forEach((el) => {
  const link = el.querySelector("a");
  if (!link) return;

  el.style.cursor = "pointer";
  el.addEventListener("click", (e) => {
    // prevent double navigation if user clicked the actual link
    if (e.target.closest("a")) return;
    window.location.href = link.href;
  });
});

/* Search intent filters: keep multi-word jewellery searches precise. */
(() => {
  const formSelector = 'form.search-form';
  const injectedAttribute = 'data-search-intent-filter';
  const displayTermParameter = 'display_q';

  const normalizeSearchTerm = (value) =>
    value
      .toLocaleLowerCase('de')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const includesTerm = (term, values) =>
    values.some((value) => term === value || term.startsWith(`${value} `) || term.endsWith(` ${value}`) || term.includes(` ${value} `));

  const removeRecognizedTerms = (term, values) =>
    [...new Set(values)]
      .sort((first, second) => second.length - first.length)
      .reduce(
        (remaining, value) =>
          ` ${remaining} `.replaceAll(` ${value} `, ' ').replace(/\s+/g, ' ').trim(),
        term
      );

  const appendFilter = (form, name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute(injectedAttribute, '');
    form.appendChild(input);
  };

  const applySearchIntentFilters = (form) => {
    form.querySelectorAll(`[${injectedAttribute}]`).forEach((input) => input.remove());

    const searchInput = form.querySelector('input[name="q"]');
    const originalTerm = searchInput ? searchInput.value.trim() : '';
    const term = normalizeSearchTerm(originalTerm);
    if (!term) return;

    const recognizedTerms = [];
    let productTypes = [];
    if (includesTerm(term, ['ohrring kette', 'ohrring ketten', 'ohrringkette', 'ohrringketten', 'ohr kette', 'ohr ketten', 'ohrkette', 'ohrketten', 'piercing kette', 'piercing ketten', 'piercingkette', 'piercingketten', 'ear chain', 'ear chains', 'earring chain', 'earring chains'])) {
      productTypes = ['Ohrring Ketten'];
      recognizedTerms.push('ohrring kette', 'ohrring ketten', 'ohrringkette', 'ohrringketten', 'ohr kette', 'ohr ketten', 'ohrkette', 'ohrketten', 'piercing kette', 'piercing ketten', 'piercingkette', 'piercingketten', 'ear chain', 'ear chains', 'earring chain', 'earring chains');
    } else if (includesTerm(term, ['halskette', 'halsketten', 'necklace', 'necklaces'])) {
      productTypes = ['Halsketten'];
      recognizedTerms.push('halskette', 'halsketten', 'necklace', 'necklaces');
    } else if (includesTerm(term, ['kette', 'ketten', 'chain', 'chains'])) {
      productTypes = ['Halsketten', 'Ohrring Ketten'];
      recognizedTerms.push('kette', 'ketten', 'chain', 'chains');
    } else if (includesTerm(term, ['creole', 'creolen', 'hoop earring', 'hoop earrings', 'hoop', 'hoops', 'huggie earring', 'huggie earrings', 'huggie', 'huggies'])) {
      productTypes = ['Creolen'];
      recognizedTerms.push('creole', 'creolen', 'hoop earring', 'hoop earrings', 'hoop', 'hoops', 'huggie earring', 'huggie earrings', 'huggie', 'huggies');
    } else if (includesTerm(term, ['ohrstecker', 'stecker', 'stud earring', 'stud earrings', 'ear stud', 'ear studs', 'earring stud', 'earring studs', 'stud', 'studs'])) {
      productTypes = ['Ohrstecker'];
      recognizedTerms.push('ohrstecker', 'stecker', 'stud earring', 'stud earrings', 'ear stud', 'ear studs', 'earring stud', 'earring studs', 'stud', 'studs');
    } else if (includesTerm(term, ['clicker ring', 'clicker rings', 'clicker', 'clickers'])) {
      productTypes = ['Clicker'];
      recognizedTerms.push('clicker ring', 'clicker rings', 'clicker', 'clickers');
    } else if (includesTerm(term, ['ohrring anhanger', 'ohrring anhaenger', 'earring charm', 'earring charms', 'ear charm', 'ear charms', 'anhanger', 'anhaenger', 'charm', 'charms'])) {
      productTypes = ['Ohrring Anhänger'];
      recognizedTerms.push('ohrring anhanger', 'ohrring anhaenger', 'earring charm', 'earring charms', 'ear charm', 'ear charms', 'anhanger', 'anhaenger', 'charm', 'charms');
    } else if (includesTerm(term, ['armband', 'armbander', 'bracelet', 'bracelets'])) {
      productTypes = ['Armbänder'];
      recognizedTerms.push('armband', 'armbander', 'bracelet', 'bracelets');
    } else if (includesTerm(term, ['earring', 'earrings'])) {
      productTypes = ['Creolen', 'Ohrstecker', 'Clicker'];
      recognizedTerms.push('earring', 'earrings');
    }

    const isEnglish = document.documentElement.lang
      .toLowerCase()
      .startsWith('en');

    let material = '';
    if (includesTerm(term, ['weissgold', 'white gold'])) {
      material = isEnglish ? '14k White Gold' : '585 Weißgold';
      recognizedTerms.push('weissgold', 'white gold');
    } else if (includesTerm(term, ['gelbgold', 'yellow gold', 'gold'])) {
      material = isEnglish ? '14k Yellow Gold' : '585 Gelbgold';
      recognizedTerms.push('gelbgold', 'yellow gold', 'gold');
    }

    let piercingPosition = '';
    if (includesTerm(term, ['high lobe', 'highlobe', 'upper lobe', 'upperlobe'])) {
      piercingPosition = 'High Lobe';
      recognizedTerms.push('high lobe', 'highlobe', 'upper lobe', 'upperlobe');
    } else if (includesTerm(term, ['helix'])) {
      piercingPosition = 'Helix';
      recognizedTerms.push('helix');
    } else if (includesTerm(term, ['conch'])) {
      piercingPosition = 'Conch';
      recognizedTerms.push('conch');
    } else if (includesTerm(term, ['tragus'])) {
      piercingPosition = 'Tragus';
      recognizedTerms.push('tragus');
    } else if (includesTerm(term, ['daith'])) {
      piercingPosition = 'Daith';
      recognizedTerms.push('daith');
    } else if (includesTerm(term, ['rook'])) {
      piercingPosition = 'Rook';
      recognizedTerms.push('rook');
    } else if (includesTerm(term, ['industrial'])) {
      piercingPosition = 'Industrial';
      recognizedTerms.push('industrial');
    } else if (includesTerm(term, ['flat', 'scapha'])) {
      piercingPosition = 'Flat';
      recognizedTerms.push('flat', 'scapha');
    } else if (includesTerm(term, ['ear lobe', 'earlobe', 'lobe'])) {
      piercingPosition = 'Lobe';
      recognizedTerms.push('ear lobe', 'earlobe', 'lobe');
    }

    if (piercingPosition) recognizedTerms.push('piercing');

    if (material && includesTerm(term, ['14k', '14 karat', '585'])) {
      recognizedTerms.push('14k', '14 karat', '585');
    }

    const isPiercingRing =
      piercingPosition &&
      includesTerm(term, ['ring', 'piercing ring', 'piercingring']);

    if (isPiercingRing) {
      productTypes = piercingPosition === 'Daith' ? [] : ['Clicker', 'Creolen'];
      recognizedTerms.push('ring', 'piercing ring', 'piercingring');
    }

    if (searchInput && (productTypes.length || material || piercingPosition)) {
      searchInput.value = removeRecognizedTerms(term, recognizedTerms) || '*';
      appendFilter(form, displayTermParameter, originalTerm);
    }

    productTypes.forEach((productType) =>
      appendFilter(form, 'filter.p.product_type', productType)
    );
    if (material) appendFilter(form, 'filter.p.m.theme.siblings_color', material);
    if (piercingPosition) appendFilter(form, 'filter.p.m.custom.piercingposition', piercingPosition);
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && form.matches(formSelector)) {
        applySearchIntentFilters(form);
        observeSearchDisplayUpdates();
      }
    },
    true
  );

  const restoreSearchDisplayTerm = () => {
    const params = new URLSearchParams(window.location.search);
    const displayTerm = params.get(displayTermParameter);
    const searchTerm = params.get('q');

    if (!displayTerm || !searchTerm) return;

    document
      .querySelectorAll(`${formSelector} input[name="q"]`)
      .forEach((input) => {
        input.value = displayTerm;
      });

    const replaceSearchTerm = (value) => {
      if (!value) return value;

      return value
        .replaceAll(`"${searchTerm}"`, `"${displayTerm}"`)
        .replaceAll(`„${searchTerm}“`, `„${displayTerm}“`)
        .replaceAll(`“${searchTerm}”`, `“${displayTerm}”`);
    };

    document.querySelectorAll('[data-results-count]').forEach((element) => {
      const nextText = replaceSearchTerm(element.textContent);
      if (nextText !== element.textContent) element.textContent = nextText;
    });

    const nextTitle = replaceSearchTerm(document.title);
    if (nextTitle !== document.title) document.title = nextTitle;

    document.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      const isSearchLink =
        url.origin === window.location.origin &&
        url.pathname.endsWith('/search') &&
        url.searchParams.has('q');

      if (!isSearchLink || url.searchParams.has(displayTermParameter)) return;

      url.searchParams.set(displayTermParameter, displayTerm);
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });

    document.querySelectorAll('form[action]').forEach((form) => {
      const action = new URL(form.action, window.location.origin);
      const isSearchForm =
        action.origin === window.location.origin &&
        action.pathname.endsWith('/search');

      if (!isSearchForm || form.querySelector(`input[name="${displayTermParameter}"]`)) return;
      appendFilter(form, displayTermParameter, displayTerm);
    });
  };

  let searchDisplayObserver;
  let searchDisplayObserverTimer;
  let searchDisplayUpdateScheduled = false;

  const scheduleSearchDisplayRestore = () => {
    if (searchDisplayUpdateScheduled) return;
    searchDisplayUpdateScheduled = true;

    window.requestAnimationFrame(() => {
      searchDisplayUpdateScheduled = false;
      restoreSearchDisplayTerm();
    });
  };

  const observeSearchDisplayUpdates = () => {
    if (!document.body.classList.contains('template-search')) return;

    if (searchDisplayObserver) searchDisplayObserver.disconnect();
    window.clearTimeout(searchDisplayObserverTimer);

    searchDisplayObserver = new MutationObserver(scheduleSearchDisplayRestore);
    searchDisplayObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    searchDisplayObserverTimer = window.setTimeout(() => {
      if (searchDisplayObserver) searchDisplayObserver.disconnect();
      searchDisplayObserver = undefined;
      restoreSearchDisplayTerm();
    }, 5000);
  };

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;

      const url = new URL(link.href, window.location.origin);
      const updatesSearchResults =
        url.origin === window.location.origin &&
        url.pathname.endsWith('/search') &&
        url.searchParams.has(displayTermParameter);

      if (updatesSearchResults) observeSearchDisplayUpdates();
    },
    true
  );

  const initializeSearchDisplayTerm = () => {
    restoreSearchDisplayTerm();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSearchDisplayTerm, {
      once: true,
    });
  } else {
    initializeSearchDisplayTerm();
  }
})();


/* Sibling variant preservation */
(() => {
  const containerSelector = '[data-current-variant-options]';
  const linkSelector = '[data-sibling-base-url][data-sibling-variants]';

  const sameOptions = (first, second) =>
    Array.isArray(first) &&
    Array.isArray(second) &&
    first.length === second.length &&
    first.every((value, index) => String(value) === String(second[index]));

  const parseJson = (value, fallback = []) => {
    try {
      return JSON.parse(value || '');
    } catch (error) {
      return fallback;
    }
  };

  const updateLink = (link, selectedOptions) => {
    const baseUrl = link.dataset.siblingBaseUrl;
    const variants = parseJson(link.dataset.siblingVariants);
    const matchingVariant = variants.find((variant) =>
      sameOptions(variant.options, selectedOptions)
    );

    if (!baseUrl) return;

    if (!matchingVariant) {
      link.setAttribute('href', baseUrl);
      return;
    }

    const variantUrl = new URL(baseUrl, window.location.origin);
    variantUrl.searchParams.set('variant', matchingVariant.id);
    link.setAttribute(
      'href',
      `${variantUrl.pathname}${variantUrl.search}${variantUrl.hash}`
    );
  };

  const updateContainer = (container, selectedOptions) => {
    container
      .querySelectorAll(linkSelector)
      .forEach((link) => updateLink(link, selectedOptions));
  };

  const initialize = (root = document) => {
    root.querySelectorAll(containerSelector).forEach((container) => {
      const selectedOptions = parseJson(
        container.dataset.currentVariantOptions
      );
      updateContainer(container, selectedOptions);
    });
  };

  const initializePage = () => initialize(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePage, {
      once: true,
    });
  } else {
    initializePage();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });

  document.addEventListener('theme:variant:change', (event) => {
    const selectedOptions = event.detail?.variant?.options;
    if (!Array.isArray(selectedOptions)) return;

    const target = event.target;
    const scope =
      target instanceof Element
        ? target.closest('product-component, quick-add-product, [data-product]')
        : null;

    (scope || document)
      .querySelectorAll(containerSelector)
      .forEach((container) => {
        container.dataset.currentVariantOptions =
          JSON.stringify(selectedOptions);
        updateContainer(container, selectedOptions);
      });
  });
})();

(() => {
  const source = 'https://static.klaviyo.com/onsite/js/Yi4egK/klaviyo.js?company_id=Yi4egK';
  let started = false;
  const formSelector = '[class*="klaviyo-form-"]';

  const load = () => {
    if (started || document.querySelector(`script[src="${source}"]`)) return;
    started = true;

    const script = document.createElement('script');
    script.async = true;
    script.src = source;
    document.head.appendChild(script);
  };

  const loadForFormInteraction = (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest(formSelector)) return;
    load();
  };

  document.addEventListener('focusin', loadForFormInteraction, true);
  document.addEventListener('pointerdown', loadForFormInteraction, {
    capture: true,
    passive: true,
  });

  const observeForms = () => {
    const forms = document.querySelectorAll(formSelector);
    if (!forms.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        load();
      },
      { rootMargin: '400px 0px' }
    );

    forms.forEach((form) => observer.observe(form));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeForms, { once: true });
  } else {
    observeForms();
  }

  const scheduleFallback = () => {
    window.setTimeout(() => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(load, { timeout: 2000 });
        return;
      }

      load();
    }, 10000);
  };

  if (document.readyState === 'complete') {
    scheduleFallback();
  } else {
    window.addEventListener('load', scheduleFallback, { once: true });
  }
})();

(() => {
  const hydrate = (image) => {
    if (image.dataset.deferredLoaded === 'true') return;
    image.dataset.deferredLoaded = 'true';
    image.classList.add('is-loading');

    const wrapper = image.closest('[data-deferred-image-wrapper]');
    wrapper?.classList.add('is-loading');

    image.addEventListener(
      'load',
      () => {
        image.classList.remove('is-loading');
        wrapper?.classList.remove('is-loading');
      },
      { once: true }
    );

    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.sizes) image.sizes = image.dataset.sizes;
    image.src = image.dataset.src;
  };

  const initialize = (scope = document) => {
    const images = scope.querySelectorAll('[data-deferred-image]:not([data-deferred-loaded="true"])');
    if (!images.length) return;

    if (!('IntersectionObserver' in window)) {
      images.forEach(hydrate);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          hydrate(entry.target);
        });
      },
      { rootMargin: '700px 600px' }
    );

    images.forEach((image) => observer.observe(image));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();


/* Variant-specific piercing-position badges */
(() => {
  const guideSelector = '[data-cro-test="fit-guide"]';
  const mapSelector = '[data-cro-fit-map]';
  const positionsSelector = '[data-cro-fit-positions]';

  const cleanPositions = (value) =>
    Array.isArray(value)
      ? value
          .filter((position) => typeof position === 'string' && position.trim())
          .map((position) => position.trim())
      : [];

  const updateGuide = (guide, variantId) => {
    const mapNode = guide.querySelector(mapSelector);
    const list = guide.querySelector(positionsSelector);
    if (!mapNode || !list || !variantId) return;

    let data;
    try {
      data = JSON.parse(mapNode.textContent);
    } catch (error) {
      return;
    }

    const variantPositions = cleanPositions(
      data?.variants?.[String(variantId)]
    );
    const fallbackPositions = cleanPositions(data?.fallback);
    const positions = variantPositions.length
      ? variantPositions
      : fallbackPositions;

    list.replaceChildren(
      ...positions.map((position) => {
        const item = document.createElement('li');
        item.textContent = position;
        return item;
      })
    );
    guide.hidden = positions.length === 0;
  };

  document.addEventListener('theme:variant:change', (event) => {
    const variantId = event.detail?.variant?.id;
    if (!variantId) return;

    const target = event.target;
    const scope =
      target instanceof Element
        ? target.closest('product-component, quick-add-product, [data-product]')
        : null;

    (scope || document)
      .querySelectorAll(guideSelector)
      .forEach((guide) => updateGuide(guide, variantId));
  });
})();
